import React from 'react';
import { Form } from 'antd';

import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import AgeAgreementWarning from 'components/AgeAgreementWarning';
import Contract from 'components/Contract';
import PermissionSplash from 'components/PermissionSplash';

class Agreements extends React.Component {
	state = {
		SRI_AGREE_TANDC: null,
		SRI_AGREE_COFC: null,
		SRI_AGREE_GR: null,
		SRI_AGREE_CSU_TRAN: null,
		SRI_AGREE_FERPA: null
	}
	getStatusesFromProps = (props) => {
		const statuses = props.statuses || {};
		this.setState({
			SRI_AGREE_TANDC: statuses.SRI_AGREE_TANDC,
			SRI_AGREE_COFC: statuses.SRI_AGREE_COFC,
			SRI_AGREE_GR: statuses.SRI_AGREE_GR,
			SRI_AGREE_CSU_TRAN: statuses.SRI_AGREE_CSU_TRAN,
			SRI_AGREE_FERPA: statuses.SRI_AGREE_FERPA
		});
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.updateStatuses(this.props.form, 'R', null)
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}
	componentDidMount() { this.getStatusesFromProps(this.props); }
	componentWillReceiveProps(nextProps) { this.getStatusesFromProps(nextProps); }
	render() {
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'agreements');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'Agreements' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Form className="withSpacing" onSubmit={this.handleSubmit}>
					<p>
						Prior to the start of your voyage it is necessary to acknowledge that you have read and agree to the terms of the below documents.
						Please click on each document and read the contents carefully.
						It is recommended that you print all documents for your records.
						After you have read all documents you must select each box to acknowledge that you have read and agree to the terms.
						Once all boxes are checked you may click the Save button.<br />
						<strong>**Please note: Signing of online agreements is a requisite for, but not a guarantee of, a berth on a Semester at Sea Voyage.</strong>
					</p>
					<AgeAgreementWarning />

					<Contract
						getFieldDecorator={getFieldDecorator}
						field="SRI_AGREE_TANDC"
						initialValue={this.state.SRI_AGREE_TANDC}
						title="Ticket Contract Term and Conditions"
						link="http://www.semesteratsea.org/wp-content/uploads/2016/07/Ticket-Contract-July-2016.pdf"
						agreeText="This document is a contract. All of its provisions are important. I have reviewed and understand the terms and conditions of my ticket contract." />

					<Contract
						getFieldDecorator={getFieldDecorator}
						field="SRI_AGREE_COFC"
						initialValue={this.state.SRI_AGREE_COFC}
						title="Acknowledgement of Code of Conduct Agreement/Consent for Searches and Testing"
						link="http://www.semesteratsea.org/wp-content/uploads/2016/07/Student-Code-of-Conduct-Agreement_Jan.2016.pdf"
						agreeText="I understand and agree to be held responsible for adhering to the regulations, policies, and procedures stated in the Institute for Shipboard Education’s (ISE) Voyager’s Handbook." />

					<Contract
						getFieldDecorator={getFieldDecorator}
						field="SRI_AGREE_GR"
						initialValue={this.state.SRI_AGREE_GR}
						title="General Release and Acknowledgement of Consent"
						link="http://www.semesteratsea.org/wp-content/uploads/2016/07/GeneralReleaseJan.2016.pdf"
						extraText='In consideration of the acceptance to participate on the Semester at Sea program ("Program"), on the MV World Odyssey or other vessel substituted in its place ("Vessel"), and recognizing that his or her participation in the Program is voluntary, and that there are certain risks which the undersigned participant ("Participant") assumes by participation in the Program, the Participant hereby enters into the following General Release and Acknowledgement of Consent ("Release and Consent").'
						agreeText="By checking this box I acknowledge that I have read and agree to the terms of the Release and Consent" />

					{this.props.isStudent &&
						<Contract
							getFieldDecorator={getFieldDecorator}
							field="SRI_AGREE_CSU_TRAN"
							initialValue={this.state.SRI_AGREE_CSU_TRAN}
							title="CSU Transcript Release"
							link="http://www.semesteratsea.org/wp-content/uploads/2016/07/CSU-Transcript-Release-Consent_Jan.2016.pdf"
							extraText="I have read the explanation of the CSU Transcript Release Consent Form. I consent to understanding any financial holds at the conclusion of the voyage will result in a forfeiture of a courtesy copy of my transcript and that I will be liable for ordering a transcript at my own cost."
							agreeText="By checking this box I acknowledge that I have read and agree to the terms CSU Transcript Release" />
					}

					{this.props.isStudent &&
						<Contract
							getFieldDecorator={getFieldDecorator}
							field="SRI_AGREE_FERPA"
							initialValue={this.state.SRI_AGREE_FERPA}
							title="Authorization to Release Information (FERPA)"
							link="http://www.semesteratsea.org/wp-content/uploads/2016/07/Student-Authorization-to-Release-Information-FERPA-CSU_Jan.2016.pdf"
							extraText="I authorize Semester at Sea and Colorado State University personnel to discuss the information outlined in this document for the purposes of understanding and meeting program related financial obligations with me (the student) as well as the person(s) listed as my emergency contact(s)."
							agreeText="By checking this box I acknowledge that I have read and agree to the terms of the Authorization to Release Information (FERPA)" />
					}
					{this.props.variant !== 'admin' &&
						<SaveButton
							disabled={!this.props.form.isFieldsTouched()}
							loading={this.props.getStatus().submitting} />
					}
				</Form>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}

export default withSpin(Form.create()(Agreements));


// WEBPACK FOOTER //
// ./portal-components/Portal/Agreements/index.jsx